var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-invention-list" }, [
    _c("div", { staticClass: "block-title" }, [
      _c("div", { staticClass: "dot" }),
      _vm._v(" " + _vm._s(_vm.$t("user.UserInventionList.title")) + " "),
    ]),
    _c("div", { staticClass: "current" }, [
      _c("div", { staticClass: "block-sub-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("user.UserInventionList.subtitle")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "current-table-block apply-table" },
        [
          _c("v-data-table", {
            staticClass: "current-table",
            attrs: {
              headers: _vm.currentHeaders,
              items: _vm.current,
              "disable-pagination": true,
              "disable-filtering": true,
              "hide-default-footer": true,
              "disable-sort": true,
              "no-data-text": _vm.$t("user.UserInventionList.nodata"),
            },
            scopedSlots: _vm._u([
              {
                key: "item.status",
                fn: function ({ item }) {
                  return [
                    item.status == "draft"
                      ? _c(
                          "div",
                          {
                            staticClass: "edit-btn action-btn",
                            on: {
                              click: function ($event) {
                                return _vm.editItem(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("user.UserInventionList.draft")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    item.status == "submit"
                      ? _c("div", { staticClass: "apply-btn action-btn" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("user.UserInventionList.submit")) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }